export default __webpack_public_path__ + "static/media/spotify.9e36fed6.svg";